import script from "./LicensePlateCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LicensePlateCard.vue?vue&type=script&setup=true&lang=ts"

import "./LicensePlateCard.vue?vue&type=style&index=0&id=7e2a248e&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2a248e"]])

export default __exports__